import { FC, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { isEmpty } from 'lodash';

import { DateFilters, facet } from '@app/components';
import { useSearchContext } from '@app/contexts';
import { sharedMessages } from '@app/translations';

import { Facet } from '../Facet';

interface PublicationYearFacetProps {
  activeFacetAttributesCount: number;
  setActiveFacetAttributesCount: (value: number) => void;
}

export const PublicationYearFacet: FC<PublicationYearFacetProps> = ({
  activeFacetAttributesCount,
  setActiveFacetAttributesCount,
}) => {
  const { $t } = useIntl();
  const { activePublicationYear, setActivePublicationYear } =
    useSearchContext();

  const dateFiltersLabel = $t(sharedMessages.publicationYear);

  useEffect(() => {
    setActiveFacetAttributesCount(!isEmpty(activePublicationYear) ? 1 : 0);
  }, [activePublicationYear, setActiveFacetAttributesCount]);

  return (
    <Facet
      label={dateFiltersLabel}
      customAttributes={
        <DateFilters
          key="dateFilters"
          ariaLabel={dateFiltersLabel}
          selectedDateRange={activePublicationYear}
          onDateRangeChange={setActivePublicationYear}
        />
      }
      values={null}
      facetKey={facet.publication_year}
      activeFacetAttributesCount={activeFacetAttributesCount}
      isInitiallyExpanded={activeFacetAttributesCount > 0}
    />
  );
};
